import {
  ContainerPositionSnapshot,
  CreateHousekeepingPlanRequest,
  PositionDto,
  RowFillDirection,
  SequencingStrategy,
} from '@yard/app/api'
import {
  HousekeepingPlanFillDirection,
  HousekeepingPlanSequencingStrategy,
  ICreateHousekeepingPlanFormData,
} from '../../../models/yard-setup.model'

const SEQUENCING_STRATEGY_MAP: Record<HousekeepingPlanSequencingStrategy, SequencingStrategy> = {
  [HousekeepingPlanSequencingStrategy.OperatorConvenience]: SequencingStrategy.OperatorConvenience,
}

const FILL_DIRECTION_MAP: Record<HousekeepingPlanFillDirection, RowFillDirection> = {
  [HousekeepingPlanFillDirection.BayFirst]: RowFillDirection.BayFirst,
  [HousekeepingPlanFillDirection.RowFirst]: RowFillDirection.RowFirst,
}

export const mapFormToCreatePlanRequest = (
  formData: ICreateHousekeepingPlanFormData,
  containerPositions: ContainerPositionSnapshot[],
  destinationAreas: PositionDto[],
): CreateHousekeepingPlanRequest => ({
  name: formData.name || undefined,
  containerPositions,
  destinationBlockId: formData.blockId,
  destinationAreas,
  sequencingStrategy: SEQUENCING_STRATEGY_MAP[formData.sequencingStrategy],
  rowFillDirection: FILL_DIRECTION_MAP[formData.fillDirection],
  dispatchWhatFits: formData.dispatchWhatFits,
})
